<div class="businessRule">
  <div class="row">
    <div class="col-md-3">
      <h2 mat-dialog-title>Business Rule Analysis For : {{webNum}} </h2>
    </div>
    <div class="col-md-9 text-left mt-4 diclaimermsg">{{this.disclaimerMessage}}</div>
  </div>
  <mat-dialog-content style="margin-left:20px; margin-right: 20px;padding: 0px;">
    <table mat-table #productTable [dataSource]="gridDataList" multiTemplateDataRows matSort matSortDirection="desc" class="matTables productTable resultTable">
      <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
        <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product </th>
</div>
<div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="pricePerUnit">Item# </th></div>
<div *ngIf="column=='orderType'"><th mat-header-cell *matHeaderCellDef class="pricePerUnit">Order Type </th></div>
<div *ngIf="column=='itemFlashMessage'"><th mat-header-cell *matHeaderCellDef class="pricingBlock text-center">ItemFlash Message</th></div>
<div *ngIf="column=='proprietary'"><th mat-header-cell *matHeaderCellDef class="pricePerUnit">Vended/Proprietary</th></div>
<div *ngIf="column=='packaged'"><th mat-header-cell *matHeaderCellDef class="pricePerUnit text-center">Bulk/Packaged</th></div>
<div *ngIf="column=='xrefCheckBK'"><th mat-header-cell *matHeaderCellDef class="pricePerUnit">XrefCheckBK </th></div>
<div *ngIf="column=='omniumBP'"><th mat-header-cell *matHeaderCellDef class="pricePerUnit text-center">OmniumBP</th></div>
<div *ngIf="column=='supplierNumber'"><th mat-header-cell *matHeaderCellDef class="pricingBlock text-center">Supplier Number</th></div>
<div *ngIf="column=='successfullyProcessed'"><th mat-header-cell *matHeaderCellDef class="pricingBlock text-center">Successfully Processed</th></div>
<div *ngIf="column=='deliveryDate'"><th mat-header-cell *matHeaderCellDef class="pricePerUnit text-center">Delivery Date</th></div>
<div *ngIf="column=='errorMessage'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock text-center">Error Message</th></div>

<td mat-cell *matCellDef="let element">
  <div *ngIf="column=='product'">
    <div class="order-info">
      <p>{{element.itemVendorName}}</p>
      <p class="grower-name">{{element.itemDescription}}</p>
      <p><span *ngIf="element.yourPrice  && plAccess==true" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
      <p><span *ngIf="element.paymentTerms  && plAccess==true" class="paymentTerm">{{element.paymentTerms}}</span></p>
    </div>
  </div>
  <div *ngIf="column=='itemNumber'">
    <p> {{element.itemNumber}} </p>
  </div>
  <!--<div *ngIf="column=='pricingUOM'" class="text-center">
    <p> {{element.pricingUnitOfMeasure}} </p>
  </div>
  <div *ngIf="column=='pricePerUnitPricingUOM'" class="measureUnit text-center">
    <p> {{element.pricePerUnit | number:'1.4-4'}} </p>
  </div>
  <div *ngIf="column=='packageSize'" class="measureUnit text-center">
    <p> {{element.packageSize}} </p>
  </div>
  <div *ngIf="column=='quantity'" class="quantityBlock text-center">
    <div>
      <input readonly type="text" class="geu-txt unitsText" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.quantity==0 || element.quantity=='')}" />
    </div>
  </div>
  <div *ngIf="column=='orderUOM'" class="text-center">
    <p> {{element.uom}} </p>
  </div>
  <div *ngIf="column=='pricePerUnitOrderUOM'" class="text-center">
    <p> {{element.price | number:'1.4-4'}} </p>
  </div>
  <div *ngIf="column=='itemTotal'">
    <div class="text-center"> {{element.quantity * element.price | number:'1.4-4'}} </div>
  </div>-->
  <div *ngIf="column=='orderType'" class="text-center">
    <p> {{element.orderType}} </p>
  </div>
  <div *ngIf="column=='itemFlashMessage'" class="text-center">
    <p> {{element.itemFlashMsg}} </p>
  </div>
  <div *ngIf="column=='proprietary'" class="text-center">
    <p> {{element.vendedProprietary}} </p>
  </div>
  <div *ngIf="column=='packaged'" class="text-center">
    <p> {{element.bulkPackaged}} </p>
  </div>
  <div *ngIf="column=='xrefCheckBK'" class="text-center">
    <p> {{element.xrefCheckBK}} </p>
  </div>
  <div *ngIf="column=='omniumBP'" class="text-center">
    <p> {{element.omniumBP}} </p>
  </div>
  <!--<div *ngIf="column=='itemVendor'" class="text-center">
    <p> {{element.itemVendorName}} </p>
  </div>-->
  <div *ngIf="column=='supplierNumber'" class="text-center">
    <p> {{element.supplierNumber}} </p>
  </div>
  <div *ngIf="column=='successfullyProcessed'" class="text-center">
    <p> {{element.successfullyProcessed}} </p>
  </div>
  <div *ngIf="column=='deliveryDate'" class="deliveryDateBlock">
    <div class="text-center deliveryDatePicker">
      <span>{{(element.deliveryDate) | date:'MM/dd/yyyy'}}</span>
    </div>
  </div>
  <div *ngIf="column=='errorMessage'" class="text-center">
    <p> {{element.errorMessage}} </p>
  </div>
</td>
      </ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
<tr mat-row *matRowDef="let element; columns: displayedColumns;"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"></tr>
    </table>
<div *ngIf="gridDataList == undefined || gridDataList?.length == 0" class="noDataMsg">
  <p>No Record Found.</p>
</div>
  </mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="btns alighRight" color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
</div>
